import { AnyAction } from 'redux';
import { put, select, takeEvery } from 'redux-saga/effects';

import { actions } from '../../../../components/conversation/actions/conversation';
import { notificationActions } from '../../../../components/notifications/actions/notification';
import { twilioActions } from '../actions/twilioActions';

const { notificationAdd } = notificationActions;

const {
  twilioDisconnectCall,
  twilioConnectCallSucceeded,
  twilioMakeCallFailed,
  twilioMakeInternalCallFailed,
  twilioMakeCallbackFailed,
  twilioConnectCallFailed,
} = twilioActions;

const { conversationGetSucceeded } = actions;

// Saga
export const twilio = [
  takeEvery(conversationGetSucceeded.toString(), conversationGetSucceededGen),
  takeEvery(
    twilioConnectCallSucceeded.toString(),
    twilioConnectCallSucceededGen,
  ),
  takeEvery(twilioMakeCallFailed.toString(), twilioMakeCallFailedGen),
  takeEvery(twilioMakeInternalCallFailed.toString(), twilioMakeCallFailedGen),
  takeEvery(twilioMakeCallbackFailed.toString(), twilioMakeCallFailedGen),
  takeEvery(twilioConnectCallFailed.toString(), twilioMakeCallFailedGen),
];

function* twilioMakeCallFailedGen() {
  // @TODO show notification telling the agent that the call just failed.
  const option = {
    title: 'Could not start the call',
    text: `An error occurred`,
    className: 'warning',
    icon: 'i-info',
  };
  yield put(notificationAdd(option));
}

function* conversationGetSucceededGen(action: AnyAction) {
  // Look at the conversation type and if it closed.
  // if it is pstnphone or callback we should lookup our
  // current conversation and see if the csid is the same.
  const conversation = Object.assign(
    {},
    action.payload.data.history.main_conversation,
  );
  if (conversation.is_closed === true) {
    if (
      conversation.initial_channel === 'pstnphone' ||
      conversation.initial_channel === 'callback'
    ) {
      const getTelephony = (state) => state.telephony;
      const telephonyState = yield select(getTelephony);

      if (
        telephonyState.currentCall &&
        telephonyState.currentCall.csid === conversation.id
      ) {
        const getTelephony = (state) => state.telephony;
        const telephony = yield select(getTelephony);
        console.warn('telephony.currentCall', telephony.currentCall);
        // This would just start to closed all current open phone conversations :(
        console.warn(
          'CONVERSATION GET - TWILIO DISCONNECTED CALL SHOULD BE CALLED HERE!!!',
        );
        // The conversation has been closed - we most have missed the WS event.
        yield put(twilioDisconnectCall({ csid: conversation.id }));
      }
    }
  }
}

function* twilioConnectCallSucceededGen(action: AnyAction) {
  const getConversations = (state) => state.conversations;
  const conversationsState = yield select(getConversations);

  for (const metaConversation of conversationsState.metaConversations) {
    if (
      metaConversation.conversation.status === 'closed' &&
      metaConversation.conversation.id === action.payload.csid
    ) {
      console.warn(
        'TWILIO CONNECT CALL SUCCEEDED - TWILIO DISCONNECTED CALL SHOULD BE CALLED HERE!!!',
      );
      yield put(twilioDisconnectCall({ csid: action.payload.csid }));
    }
  }
}
